import React from "react";
import "./styles.css";

const ExitIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container icon-margin-right">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g transform="matrix(15.65,0,0,15.65,-88.2997,-72.6494)">
            <path
              d="M12.879,12.879C13.441,12.316 14.204,12 15,12L22,12C22.796,12 23.559,12.316 24.121,12.879C24.684,13.441 25,14.204 25,15L25,17C25,17.552 24.552,18 24,18C23.448,18 23,17.552 23,17L23,15C23,14.735 22.895,14.48 22.707,14.293C22.52,14.105 22.265,14 22,14L15,14C14.735,14 14.48,14.105 14.293,14.293C14.105,14.48 14,14.735 14,15L14,27C14,27.265 14.105,27.52 14.293,27.707C14.48,27.895 14.735,28 15,28L22,28C22.265,28 22.52,27.895 22.707,27.707C22.895,27.52 23,27.265 23,27L23,25C23,24.448 23.448,24 24,24C24.552,24 25,24.448 25,25L25,27C25,27.796 24.684,28.559 24.121,29.121C23.559,29.684 22.796,30 22,30L15,30C14.204,30 13.441,29.684 12.879,29.121C12.316,28.559 12,27.796 12,27L12,15C12,14.204 12.316,13.441 12.879,12.879ZM27.293,17.293C27.683,16.902 28.317,16.902 28.707,17.293L31.707,20.293C31.885,20.471 31.982,20.7 31.998,20.933C32.002,20.998 32,21.064 31.992,21.129C31.967,21.318 31.889,21.502 31.756,21.655C31.739,21.675 31.721,21.694 31.702,21.712L28.707,24.707C28.317,25.098 27.683,25.098 27.293,24.707C26.902,24.317 26.902,23.683 27.293,23.293L28.586,22L19,22C18.448,22 18,21.552 18,21C18,20.448 18.448,20 19,20L28.586,20L27.293,18.707C26.902,18.317 26.902,17.683 27.293,17.293Z"
              className="el-path"
            />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip-btm">
            <p>Exit</p>
            <div className="triangle-btm"></div>
          </div>
        )}
      </a>
    </div>
  );
};
export default ExitIcon;
